export default __webpack_public_path__ + "static/6-3ce054ee9f9a2b4a00646e22bb1b3799.jpg";